export const normalizeFavoriteListingIds = ids => {
  const list = Array.isArray(ids) ? ids : [];
  const seen = new Set();
  return list.filter(id => {
    if (!id || seen.has(id)) return false;
    seen.add(id);
    return true;
  });
};

export const getFavoriteListingIds = currentUser => {
  const ids = currentUser?.attributes?.profile?.privateData?.favoriteListingIds;
  return normalizeFavoriteListingIds(ids);
};

export const toggleFavoriteId = (ids, listingId) => {
  const normalized = normalizeFavoriteListingIds(ids);
  if (!listingId) return normalized;
  return normalized.includes(listingId)
    ? normalized.filter(id => id !== listingId)
    : [...normalized, listingId];
};
